import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { STORAGE_KEYS } from '../../../constants'
import { jwtDecode } from 'jwt-decode'

interface InitialStateProp {
  _id: string;
  token: string | null
  userId: string
  loginId: string
  username: string
  name: string
  role: string
}

const initialState: InitialStateProp = {
  _id: "",
  token: null,
  userId: '',
  loginId: '',
  username: '',
  name: '',
  role: '',
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: initialState,
  reducers: {
    logIntoApp: (
      state,
      action: PayloadAction<{ token: string; userId: string }>
    ) => {
      const decoded = jwtDecode<InitialStateProp>(action.payload.token)
      localStorage.setItem(STORAGE_KEYS.TOKEN, action.payload.token)
      localStorage.setItem(STORAGE_KEYS.USER_ID, action.payload.userId);

      state.token = action.payload.token
      state.username = decoded?.username || decoded?.name || decoded?.loginId || action.payload.userId;
      state.userId = decoded?._id || decoded?.userId || decoded?.loginId || action.payload.userId || "";
      state.role = decoded.role || "";
    },
    logoutApp: (state) => {
      localStorage.clear()
      state.token = null
    },
  },
})

export const { logIntoApp, logoutApp } = authSlice.actions
